<router-outlet></router-outlet>

  
<a
target="_blank"
class="float"
href="https://api.whatsapp.com/send?phone=5491168197747&amp;text=Hola"
class="float"
target="_blank">
<img class="my-float" width="25" src="assets/images/ic-whatsapp-white.svg" />
</a>
